import React, { useState } from 'react'
import { ContentByTypeLanding } from '../../components'
import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { useNavigate } from 'react-router-dom'
import { contentUrl } from '../../helpers/url'
import { useAlert } from '../../hooks'
import { useSEO } from '../../components/seo-context'
import { ToolkitPrivateRoute } from '../../components/toolkit-private-route'

const PAGE_SIZE = 10

const crumbs = [{
  name: 'Latest Updates'
}]

const NewestReleasesPage = () => {
  const [newestReleases, setNewestReleases] = useState({ content: [] })

  const navigate = useNavigate()

  const { enqueueMsg } = useAlert()

  const [getNewestReleases] = useEvent([{
    eventName: 'contentSearchTenantContent',
    onSuccess: (payload) => {
      setNewestReleases(payload)
    },
    onError: () => {
      enqueueMsg('Unable to get the latest updates', 'error')
    }
  }])

  const handleCardSelect = item => navigate(contentUrl(item, 'newest-releases'))

  const handleContentLike = (payload) => {
    const { locationId, hasRecommend, recommendCount } = payload
    setNewestReleases(current => {
      const content = current.content.map(item => {
        if (item.locationId === locationId) {
          return { ...item, hasRecommend, recommendCount }
        }
        return item
      })
      return { ...current, content }
    })
  }

  useEventsOnViewLoad(() => {
    if (!getNewestReleases.hasBeenTriggered) {
      getNewestReleases.trigger({
        filters: {
          sort: 'createdAt:desc'
        },
        size: PAGE_SIZE,
        from: 0
      })
    }
  }, [getNewestReleases])

  useSEO(
    getNewestReleases.hasBeenTriggered && !getNewestReleases.isWorking
  )

  return (
    <ContentByTypeLanding
      crumbs={crumbs}
      isLoading={getNewestReleases.isWorking}
      handleContentLike={handleContentLike}
      pageSize={PAGE_SIZE}
      items={newestReleases.content}
      pageTitle='Latest Updates'
      pageId='newest-releases'
      handleCardSelect={handleCardSelect}
    />
  )
}

const Page = () => {
  return (
    <ToolkitPrivateRoute
      featureGuard='contentHub'
      publicOnlyForPublicTenant
      element={<NewestReleasesPage />}
    />
  )
}

export {
  Page as Component
}
